import { Box, Stack } from "@mui/material";
import * as React from "react";
import { PageContent } from "../page-content.emotion";
import Dustin from "../../../assets/images/me.webp";
import OlivePC from "../../../assets/images/olive.png";
import Shufflewood from "../../../assets/images/shufflewood.webp";
import Steam from "../../../assets/images/steamLogo.png";
import Itch from "../../../assets/images/itchio_badge.png";
import { ItchLink, StyledLink } from "./home-page.emotion";
import LongCard from "../../long-card/long-card";

export default function HomePage() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <PageContent>
      <Stack
        spacing={10}
        justifyContent="center"
        mt={10}
        mr={7}
        ml={7}
        flexDirection="column"
      >
        <LongCard image={Dustin} title="Hi there, my name is Dustin">
          <p>
            I work as a Software Developer, and create games and music in my
            spare time.
          </p>
          <p>
            I'm currently working on my second game, Shufflewood, a 2D
            platformer with deck building elements.
          </p>
        </LongCard>
        <LongCard image={Shufflewood} title="Shufflewood">
          <p>
            My second game is coming soon! Go on an adventure through the
            mysterious land of Shufflewood, where you'll use a deck of cards to
            navigate challenging terrain, overcome obstacles, and defeat
            enemies.
          </p>
          <p>More information will be shared in 2026.</p>
        </LongCard>
        <LongCard image={OlivePC} title="Olive">
          <p>
            This arcade runner style game is my first game. Visit{" "}
            <StyledLink to={"/olive"}>Olive</StyledLink> for more information,
            or download it for Windows here:
          </p>
          <Box mt={1} mb={1}>
            <a
              href="https://store.steampowered.com/app/2831870/Olive/"
              target="_blank"
            >
              <img src={Steam} width={120} />
            </a>
            <ItchLink href="https://dustinhollis.itch.io/olive" target="_blank">
              <img src={Itch} width={120} />
            </ItchLink>
          </Box>
        </LongCard>
      </Stack>
    </PageContent>
  );
}
